import React from 'react';
import { StatusBadge } from '../ui/Primitives';

export const resourceType = resource => {
  const value = String(resource?.type || resource?.resourceType || 'document').toLowerCase();
  if (value === 'epub') return 'eBook';
  if (value === 'audiobook' || value === 'audio') return 'Audio';
  if (value === 'pdf') return 'PDF';
  if (value === 'video') return 'Video';
  if (value === 'event') return 'Event';
  return 'Document';
};

export default function ResourceRow({ resource, locked = false, busy = false, onOpen, actionLabel }) {
  const type = resourceType(resource);
  const moduleLabel = resource.module || resource.group || resource.folder || 'General';
  return (
    <article className="domain-resource-row">
      <div className="domain-resource-icon" aria-hidden="true">
        {type === 'Video' ? '▶' : type === 'Audio' ? '◉' : '▤'}
      </div>
      <div className="domain-resource-title">
        <strong>{resource.title || 'Untitled resource'}</strong>
        <span>{resource.description || type}</span>
      </div>
      <div className="domain-resource-type">{type}</div>
      <div className="domain-resource-module">{moduleLabel}</div>
      <div className="domain-resource-action">
        {locked ? <StatusBadge>Locked</StatusBadge> : (
          <button type="button" className="ui-text-action" disabled={busy} onClick={() => onOpen(resource)}>
            {busy ? 'Opening…' : (actionLabel || (type === 'Video' ? 'Watch →' : 'Open →'))}
          </button>
        )}
      </div>
    </article>
  );
}
